import React, { useState } from 'react';
import { Fragment } from 'components';
import { Select } from 'components/antd';
import { CarTypesData } from 'AppClient/api/BookingExternalDictionaries';
import classnames from 'classnames';
import OutsideClick from 'react-outside-click-handler';
import Icon from 'components/antd/Icon/Icon';
import { ThemeContext } from 'app-themes';

import styles from './styles.module.scss';

const getOtherType = (
	carData: CarTypesData[],
	selectedId: number | string | null
): undefined | CarTypesData => {
	if (carData) {
		return carData.find(car => {
			return car.carTypeId === selectedId;
		});
	}
	return undefined;
};

interface Props {
	carData: CarTypesData[];
	onSelect: (carTypeId: number | string) => void;
	selectedId: number | string | null;
}
const VehicleOtherTab: React.FC<Props> = ({ carData, onSelect, selectedId }) => {
	const [visible, setVisible] = useState(false);
	const otherType = getOtherType(carData, selectedId);
	const isSelected = !!otherType;
	return (
		<OutsideClick
			onOutsideClick={() => {
				if (visible) {
					setVisible(false);
				}
			}}
		>
			<ThemeContext.Consumer>
				{(theme: string) => (
					<div
						className={classnames(styles.vehicle, styles.vehicleOther, {
							active: isSelected,
							selectOpened: visible,
							[styles[`vehicle-${theme}`]]: theme !== '',
						})}
						id="vehicle--other-container"
						onClick={() => {
							setVisible(value => !value);
						}}
					>
						<div className={styles.vehicleWrapper}>
							{isSelected ? (
								<Fragment>
									<Icon type="otherGray" />
									<span className={styles.vehicleType}>
										<span className={styles.vehicleTypeName}>
											{otherType!.carTypeName}
										</span>
									</span>
									<span className={styles.vehiclePass}>
										up to {otherType!.passengerCapacity} pass
									</span>
									<input type="hidden" value="standard" />
								</Fragment>
							) : (
								<Fragment>
									<Icon type="otherGray" />
									<span className={styles.vehicleType}>Other</span>
									<span className={styles.vehiclePass} />
									<input type="hidden" value="standard" />
								</Fragment>
							)}
						</div>
						<Select
							dropdownClassName={styles.vehicleSelect}
							open={visible}
							getPopupContainer={() =>
								document.getElementById('vehicle--other-container') || document.body
							}
							style={{
								height: '100%',
								width: '100%',
								position: 'absolute',
								left: '0px',
								top: '0px',
							}}
							onSelect={(value: any) => {
								const { key } = value;
								if (key) {
									onSelect(key);
								}
							}}
							labelInValue
						>
							{carData.map(car => {
								return (
									<Select.Option
										className={styles.select1}
										value={car.carTypeId}
										key={car.carTypeId}
									>
										{car.carTypeName}
										<span>, up to {car.passengerCapacity} pass</span>
									</Select.Option>
								);
							})}
						</Select>
					</div>
				)}
			</ThemeContext.Consumer>
		</OutsideClick>
	);
};

export default VehicleOtherTab;
